import React, { useState, useEffect } from 'react';
import { Box, Divider } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CustomInput from "../../../../../../../../src/Components/CustomInput";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { withStyles } from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CustomSelect from "../../../../../../../../src/Components/CustomSelect";
import { useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { createSla } from './redux/SlaService';


const useStyles = makeStyles((theme) => ({
    formWrapper: {
        background: "#fff",
        width: "850px",
        padding: theme.spacing(3),
    },
    formWidthWrapper: {
        background: "#fff",
        width: "500px",
        padding: theme.spacing(3),
    },
    title: {
        textTransform: "capitalize",
    },
    dialog_title: {
        marginLeft: '1.5rem',
        "& h6": {
            fontWeight: "700"
        }
    },
    toggleBtn: {
        backgroundColor: "#fff",
        color: "rgb(7,121,131)",
        border: "1px solid rgb(7,121,131)",
        padding: "5px 20px",
        borderRadius: "5px 0px 0px 5px",
        "& + $toggleBtn": {
            borderRadius: "0px 5px 5px 0px"
        },

        "&.active": {
            backgroundColor: "#4089FC",
            color: "#fff"
        }
    },
    large: {
        width: theme.spacing(13),
        height: theme.spacing(13),
    },
}));

const styles: any = (theme: any) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});


interface ICurrentSelection {
    attention_status: string
    coach_name: string
    coachee_image: string
    coachee_name: string
    date_received: string | null
    id: number
    location: string
    programme_type: string
    tableData: any
    title: string
    unit: string
};

interface IProps {
    history: any,
    location: {
        hash: string
        key: string
        pathname: string
        search: string,
        state: {
            currentAssignment: ICurrentSelection
        }
    },
    match: any,
    staticContext: any,
    labelFlag: string,
    currentRowSelection: any,
    isOpen: any,
    onClose: any,
    // fetchAPI: void | Function | any
};

interface IDialogTitle {
    children: any,
    classes: any,
    onClose: any,
    other: any,
    id: string,
    // className: any
};

const DialogTitle = withStyles(styles)((props: any) => {
    const { children, classes, onClose, ...other } = props;

    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

interface IDropdownState {
    measure_meet_percentage: string
};


const SLAModal: React.FC<IProps> = (props) => {
    const { isOpen, onClose, currentRowSelection, labelFlag } = props;
    const [activeMeasureMeet, setActiveMeasureMeet] = useState<string>("")
    const [activeExceptionalCircumstance, setActiveExceptionalCircumstance] = useState<string>("")
    const [dropdownValue, setDropdownValue] = useState<any>({});
    const [textAreaValue, setTextAreaValue] = useState<any>({});

    const classes: any = useStyles();
    const location: any = useLocation();
    const dispatch: any = useDispatch();

    const percentArray = ['10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '90%', '100%'];

    useEffect(() => {
        if (activeMeasureMeet == 'false') {
            setDropdownValue({ measure_meet_percentage: "" });
        }
    }, [activeMeasureMeet])

    useEffect(() => {
        if (activeExceptionalCircumstance == "false") {
            setTextAreaValue({ exceptions: "" })
        }
    }, [activeExceptionalCircumstance])

    useEffect(() => {
        if (currentRowSelection) {
            setDropdownValue({ measure_meet_percentage: currentRowSelection?.measure_meet_percentage });
            setTextAreaValue({ exceptions: currentRowSelection?.exceptions })
            setActiveMeasureMeet(currentRowSelection?.measure_meet || 'false');
            setActiveExceptionalCircumstance(currentRowSelection?.exceptional_circumstances || 'false')
        }
    }, [currentRowSelection])

    const handleDropDownValue = (event: any) => {
        setDropdownValue({ ...dropdownValue, [event.id]: event.value })
    }

    const handleTextAreValue = (value: string, id: any) => {
        setTextAreaValue({ ...textAreaValue, [id]: value });
    }

    const handleSubmit = (e: any) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('org_sla_id', currentRowSelection?.org_sla_id);
        formData.append('assignment_id', location?.state?.currentAssignment?.id);
        formData.append('measure_meet', activeMeasureMeet);
        formData.append('measure_meet_percentage', dropdownValue?.measure_meet_percentage);
        formData.append('exceptional_circumstances', activeExceptionalCircumstance);
        formData.append('exceptions', textAreaValue?.exceptions);

        const param = {
            assignment_id: location?.state?.currentAssignment?.id
        };
        dispatch(createSla(formData, param, (): any => { onClose() }));
    }

    return (
        <>
            <Dialog open={isOpen} onClose={onClose}
                aria-labelledby="base-station-manage" fullWidth maxWidth={`${activeMeasureMeet == "true" || activeExceptionalCircumstance == "true" ? 'md' : 'sm'}` as any}
            >
                <DialogTitle id="customized-dialog-title" className={classes.dialog_title}>
                    <Typography variant="subtitle2">
                        {labelFlag == 'editAssignmentSummary' ? 'SLA' : 'SLA Exceptions'}
                    </Typography>
                </DialogTitle>
                <Divider />
                {labelFlag == 'editAssignmentSummary' ?
                    <DialogContent>
                        <div className={`${activeMeasureMeet == "true" || activeExceptionalCircumstance == "true" ? classes.formWrapper : classes.formWidthWrapper}`}>
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <Grid xs={12} style={{ marginBottom: '2rem' }} container alignItems={"center"}>
                                        <Grid item xs={4} >
                                            <Typography variant="subtitle2">Did we meet measure?</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Box>
                                                <Box component="span" className={classes.toggleBtn} style={{
                                                    backgroundColor: activeMeasureMeet == "true" ? "rgb(7,121,131)" : "#fff",
                                                    color: activeMeasureMeet == "true" ? "#fff" : "rgb(7,121,131)",
                                                    cursor: 'pointer'
                                                }} onClick={() => setActiveMeasureMeet("true")}>Yes</Box>
                                                <Box component="span" className={classes.toggleBtn} style={{
                                                    backgroundColor: activeMeasureMeet == "false" ? "rgb(7,121,131)" : "#fff",
                                                    color: activeMeasureMeet == "false" ? "#fff" : "rgb(7,121,131)",
                                                    cursor: 'pointer'
                                                }} onClick={() => setActiveMeasureMeet("false")}>No</Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid xs={12} style={{ marginBottom: '3rem' }} container alignItems={"center"}>
                                        <Grid item xs={4}>
                                        </Grid>

                                        <Grid item xs={8}>
                                            {activeMeasureMeet == "true" ?
                                                <CustomSelect
                                                    id="measure_meet_percentage"
                                                    name={'measure_meet_percentage'}
                                                    targetId={'measure_meet_percentage'}
                                                    labelText="Select Compliance Percent"
                                                    displayEmpty variant="outlined"
                                                    itemArr={percentArray}
                                                    defaultValue={dropdownValue?.measure_meet_percentage}
                                                    parentcall={handleDropDownValue}
                                                />
                                                : <></>}
                                        </Grid>
                                    </Grid>

                                    <Grid container alignItems={"center"}>
                                        <Grid item xs={4} >
                                            <Typography variant="subtitle2" >Were there exceptional circumstances?</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Box>
                                                <Box component="span" className={classes.toggleBtn} style={{
                                                    backgroundColor: activeExceptionalCircumstance == "true" ? "rgb(7,121,131)" : "#fff",
                                                    color: activeExceptionalCircumstance == 'true' ? "#fff" : "rgb(7,121,131)",
                                                    cursor: 'pointer'
                                                }} onClick={() => setActiveExceptionalCircumstance('true')}>Yes</Box>
                                                <Box component="span" className={classes.toggleBtn} style={{
                                                    backgroundColor: activeExceptionalCircumstance == 'false' ? "rgb(7,121,131)" : "#fff",
                                                    color: activeExceptionalCircumstance == 'false' ? "#fff" : "rgb(7,121,131)",
                                                    cursor: 'pointer'
                                                }} onClick={() => setActiveExceptionalCircumstance("false")}>No</Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid xs={12} container alignItems={"center"}>
                                        <Grid item xs={4}>
                                        </Grid>

                                        <Grid item xs={8}>
                                            {activeExceptionalCircumstance == "true" ?
                                                <CustomInput
                                                    style={{ marginTop: '30px' }}
                                                    id="exceptions"
                                                    name="exceptions"
                                                    targetId={'exceptions'}
                                                    variant="outlined"
                                                    placeholder="Exceptions"
                                                    multiline={true}
                                                    rows={8}
                                                    parentcall={handleTextAreValue}
                                                    value={textAreaValue?.exceptions}
                                                />
                                                : <></>}
                                        </Grid>
                                    </Grid>
                                    <Grid xs={12} container alignItems={"center"} justify={"flex-end"}
                                        style={{ marginTop: 20 }}>
                                        <Grid item xs={1} style={{ marginRight: activeMeasureMeet == "true" || activeExceptionalCircumstance == "true" ? '1.5rem' : '3rem' }}>
                                            <Button disableElevation type="submit"
                                                style={{ textTransform: 'capitalize' }}
                                                onClick={onClose}
                                                variant={"contained"}>Cancel</Button>
                                        </Grid>
                                        <Grid item xs={1} style={{ marginRight: '8px' }}>
                                            <Button disableElevation type="submit"
                                                style={{ textTransform: 'capitalize' }}
                                                variant={"contained"}
                                                color="secondary"> Update
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </div>
                            </form>
                        </div>
                    </DialogContent> : <>
                        <DialogContent style={{ margin: '0px auto' }}>
                            <div className={classes.formWrapper}>
                                <Typography variant="h2" gutterBottom>
                                    {currentRowSelection?.exceptions || 'No data found'}
                                </Typography>
                            </div>
                        </DialogContent>
                    </>}
            </Dialog>
        </>
    )
}

export default SLAModal